import React, { useState, useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Container from '@mui/material/Container'
import { useParams } from 'react-router-dom'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { getData } from '../api/indexedDBHandler'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid2'
import axios from 'axios'
import Stack from '@mui/material/Stack'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Alert from '@mui/material/Alert'
import { Snackbar, IconButton } from '@mui/material'
import {
  isOnline,
  clearTable,
  upsertDataTournaments,
} from '../api/indexedDBHandler'
import TeamSettingsCard from './Team/TeamSettingsCard'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { updateData, addRequestsData } from '../api/indexedDBHandler'
import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import ModalAddTeam from './Modal/ModalAddTeam'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import FileUploadIcon from '@mui/icons-material/FileUpload'
import CloseIcon from '@mui/icons-material/Close'
const TournamentTeams = () => {
  const { id } = useParams()
  const [alignment, setAlignment] = React.useState('Заявка одобрена')
  const [openBackdrop, setOpenBackdrop] = React.useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment)
  }
  const [teams, setTeams] = useState([])
  const [loading, setLoading] = useState(false)
  const [tournament, setTournamentName] = useState(null)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [current_count_cup, setCurrent_count_cup] = useState(1)

  const handleImpotTeamsClick = (e) => {
    e.stopPropagation() // Добавьте эту строку
    console.log('handleImpotTeamsClick')

    const getTeams = async () => {
      const results = await getData('user', 'created', true)
      const { key, value } = results[0]
      const user = {
        id: id,
        token: value.token,
        phone: value.phone,
      }
      const response = await axios.post(
        'https://admin-protocarp.ru/php/teams/importTeamsStep.php',
        {
          ...user,
        }
      )
      if (response.data.success) {
        setLoading(false)
        const teamsArray = Object.values(response.data.teams)
        console.log('teamsArray', teamsArray)
        setTeams(teamsArray)
      } else if (response.data.error_code == 404) {
        setLoading(false)
        setTeams([])
        await clearTable('user')
      } else {
        setLoading(false)
      }
    }
    getTeams()
  }

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(`https://t.me/ProtoCarpBot/registration?startapp=${id}`)
      .then(() => setOpenSnackbar(true))
      .catch((err) => console.error('Failed to copy: ', err))
  }

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false)
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))

  useEffect(() => {
    const getTournament = async () => {
      setLoading(true)
      if (isOnline()) {
        try {
          const getTeams = async () => {
            const result_tournaments = await getData('tournaments', 'id', id)
            if (result_tournaments.length > 0) {
              const { value } = result_tournaments[0]
              setCurrent_count_cup(value.current_count_cup)
              setTournamentName(value)
            }

            const results = await getData('user', 'created', true)
            const { key, value } = results[0]
            const user = {
              id: id,
              token: value.token,
              phone: value.phone,
            }
            const response = await axios.post(
              'https://admin-protocarp.ru/php/teams/getTeamsIdTournament.php',
              {
                ...user,
              }
            )
            if (response.data.success) {
              setLoading(false)
              const teamsArray = Object.values(response.data.teams)
              console.log('teamsArray', teamsArray)
              setTeams(teamsArray)
            } else if (response.data.error_code == 404) {
              setLoading(false)
              setTeams([])
              await clearTable('user')
            } else {
              setLoading(false)
            }
          }
          getTeams()
        } catch (err) {}
      } else {
        alert('Отсутствует соединение с интернетом. ')
      }
    }

    const getTournamentTeams = async () => {
      const results = await getData('user', 'created', true)
      const { key, value } = results[0]
      const user = {
        id: id,
        token: value.token,
        phone: value.phone,
      }
      const response = await axios.post(
        'https://admin-protocarp.ru/php/teams/getTeamsIdTournamentForBD.php',
        {
          ...user,
        }
      )
      if (response.data.success) {
        upsertDataTournaments('teams', response.data.teams)
      } else if (response.data.error_code == 404) {
      }
    }
    getTournament()
    getTournamentTeams()
  }, [id])

  const url_back = '/tournaments/' + id
  const childrenToggleButton = [
    <ToggleButton value="Заявка одобрена" key="Заявка одобрена">
      {/* <CheckCircleIcon style={{ fill: 'green', paddingRight: 3 }} />  */}
      Принятые заявки
    </ToggleButton>,
    // <Badge badgeContent={4} color="primary">
    <ToggleButton value="Заявка принята" key="Заявка принята">
      {/* <FiberNewIcon style={{ fill: 'blue', paddingRight: 3 }} />  */}
      Новые заявки
    </ToggleButton>,
    // </Badge>
    <ToggleButton value="Заявка отклонена" key="Заявка отклонена">
      {/* <RemoveCircleIcon style={{ fill: 'red', paddingRight: 3 }} />  */}
      Отклонённые заявки
    </ToggleButton>,
  ]

  const controlToggleButton = {
    value: alignment,
    onChange: handleChange,
    exclusive: true,
  }

  const handleSubmitTeam = async (teamData) => {
    setIsModalOpen(false)
    setOpenBackdrop(true)
    setLoading(true)
    const update_data = {
      do: 'addNewTeam',
      teamName: teamData.teamName.trim(),
      id: id,
      spName1: teamData.spName1.trim(),
      spName2: teamData.spName2.trim(),
      spName3: teamData.spName3.trim(),
      category1: teamData.category1.trim(),
      category2: teamData.category2.trim(),
      category3: teamData.category3.trim(),
      date1: teamData.date1.trim(),
      date2: teamData.date2.trim(),
      date3: teamData.date3.trim(),
      requestKey: `${id}_addNewTeam_${new Date().getTime()}`,
    }
    // const requestKey = `${id}_dellUser_${new Date().getTime()}`
    // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
    try {
      await addRequestsData('requests', {
        url: 'teams/addNewTeam.php',
        ...update_data,
      })
      await new Promise((resolve) => setTimeout(resolve, 3000))
    } catch (error) {
    } finally {
      window.location.reload()
    }
  }

  const filteredTeams = teams.filter((e) => e.team.status == alignment)
  if (tournament && teams)
    return (
      <Container sx={{ mb: 15 }}>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <div role="presentation" style={{ textAlign: 'left', width: '100%' }}>
          <Breadcrumbs maxItems={2} aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/tournaments-list">
              Турниры
            </Link>
            <Link underline="hover" color="inherit" href={url_back}>
              Редактирование
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Команды</Typography>
          </Breadcrumbs>
        </div>

        <Typography variant="h6" gutterBottom color="black" sx={{ mt: 2 }}>
          {tournament.tournament_name}
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          Изменения в этом разделе требуют наличия соединения с интернетом.
        </Alert>

        <Box sx={{ mx: 'auto', pb: 3 }}>
          <Typography variant="body2" gutterBottom>
            Ссылка для самостоятельной регистрации команд через систему
            «ПротоКарп»{' '}
            <IconButton
              size="small"
              variant="contained"
              onClick={handleCopyClick}
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Typography>

          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            message="Ссылка скопирована в буфер обмена"
            action={
              <IconButton
                size="small"
                color="inherit"
                onClick={handleCloseSnackbar}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          />
        </Box>
        {tournament.current_count_cup > 1 ? (
          <Box sx={{ mx: 'auto', pb: 3 }}>
            <Typography variant="body2" gutterBottom>
              Импорт команд из первого этапа
              <Button
                size="small"
                startIcon={<FileUploadIcon fontSize="small" />}
                onClick={handleImpotTeamsClick}
                sx={{ ml: 1 }}
              >
                Импорт
              </Button>
            </Typography>
          </Box>
        ) : (
          ''
        )}

        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}>
            <Stack spacing={2} sx={{ alignItems: 'center', marginBottom: 2 }}>
              <ToggleButtonGroup
                size="small"
                {...controlToggleButton}
                aria-label="Small sizes"
              >
                {childrenToggleButton}
              </ToggleButtonGroup>
            </Stack>
          </Grid>
          <Grid size={{ xs: 8, md: 4 }}>
            <Typography variant="body2" gutterBottom>
              В созданных вами командах спортсмены не смогут редактировать свои
              данные и использовать их снова. Подробнее ...
            </Typography>
          </Grid>
          <Grid size={{ xs: 4, md: 2 }}>
            <Button
              variant="contained"
              size="small"
              onClick={() => setIsModalOpen(true)}
            >
              создать команду
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ width: '100%' }}>
          {filteredTeams.map((item, index) => (
            <TeamSettingsCard
              key={index}
              teamData={item.team}
              athleteData={item.athlete}
            />
          ))}
        </Grid>
        <ModalAddTeam
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleSubmitTeam}
        />
      </Container>
    )
}

export default TournamentTeams
